import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [showConsultForm, setShowConsultForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    grade: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4e156fqo628c0ftt4q0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', phone: '', email: '', grade: '', message: '' });
        setTimeout(() => {
          setShowConsultForm(false);
          setSubmitStatus('idle');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section 
        id="home" 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.8), rgba(37, 99, 235, 0.8)), url('https://public.readdy.ai/ai/img_res/6657a2ff8cfe8eb975344c1065d9f614.jpg')`
        }}
      >
        <div className="w-full px-6 py-20">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="text-white">
                <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                  威斯理
                  <br />
                  <span className="text-yellow-300">美語世界</span>
                </h1>
                <p className="text-xl mb-8 leading-relaxed opacity-90">
                  專業外籍教師團隊，小班制精緻教學，為孩子打造最佳的美語學習環境。
                  課後安親照顧，讓家長安心，孩子開心！
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button size="lg" className="bg-yellow-500 hover:bg-yellow-600 text-gray-800 font-bold">
                    <i className="ri-calendar-line mr-2"></i>
                    預約參觀
                  </Button>
                  <button 
                    onClick={() => setShowConsultForm(true)}
                    className="whitespace-nowrap cursor-pointer font-medium rounded-lg transition-all duration-200 flex items-center justify-center border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-4 text-lg border-white text-white hover:bg-white hover:text-blue-600"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    立即諮詢
                  </button>
                </div>
                <div className="mt-12 grid grid-cols-3 gap-6">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-300">8+</div>
                    <div className="text-sm opacity-80">年教學經驗</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-300">200+</div>
                    <div className="text-sm opacity-80">學生家庭</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-300">95%</div>
                    <div className="text-sm opacity-80">家長滿意度</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 諮詢表單彈窗 */}
      {showConsultForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8 relative">
            <button
              onClick={() => setShowConsultForm(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>

            <h3 className="text-2xl font-bold text-gray-800 mb-6">立即諮詢</h3>

            <form id="consult-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  姓名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的姓名"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  聯絡電話 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的電話"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  電子郵件
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的電子郵件"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  學生年級
                </label>
                <select
                  name="grade"
                  value={formData.grade}
                  onChange={(e) => setFormData({ ...formData, grade: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇年級</option>
                  <option value="國小一年級">國小一年級</option>
                  <option value="國小二年級">國小二年級</option>
                  <option value="國小三年級">國小三年級</option>
                  <option value="國小四年級">國小四年級</option>
                  <option value="國小五年級">國小五年級</option>
                  <option value="國小六年級">國小六年級</option>
                  <option value="國中一年級">國中一年級</option>
                  <option value="國中二年級">國中二年級</option>
                  <option value="國中三年級">國中三年級</option>
                  <option value="高中一年級">高中一年級</option>
                  <option value="高中二年級">高中二年級</option>
                  <option value="高中三年級">高中三年級</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  諮詢內容
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="請描述您想諮詢的問題（限500字）"
                ></textarea>
                <div className="text-xs text-gray-500 mt-1 text-right">
                  {formData.message.length}/500
                </div>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 text-green-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-check-line mr-2"></i>
                  提交成功！我們會盡快與您聯繫
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  提交失敗，請稍後再試
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {isSubmitting ? '提交中...' : '提交諮詢'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
